<template>
  <el-card class="sortBox">
    <div class="flex" style="justify-content: space-between;">
      <div class="flex">
        <div style="padding: .12rem 0px;">排序：</div>
        <div @click="visitNum(item,index)" class="sortZi hand" v-for="(item,index) in sortData" :key="index">
          <span :class="item.visitType == 1 || item.visitType == 2?'visitTit active':'visitTit'">{{item.name}}</span>
          <span :style="item.visitType == 1?'color:#0077FA;font-weight:bold;':''" class="sortIcon down el-icon-sort-down"></span>
          <span :style="item.visitType == 2?'color:#0077FA;font-weight:bold;':''" class="sortIcon up el-icon-sort-up"></span>
        </div>
      </div>
      <div class="sortRight">共{{listTotal}}个{{htmlName}}</div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    listTotal: {
      type: Number,
      default: 0
    },
    htmlName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      sortData: [
        {name: '发布时间',value: 'visit',visitType: 1},{name: '访问量',value: 'visit',visitType: ''}
      ],
      sortIndex: 0,
    };
  },
  created() {
    if(this.htmlName == '专家') {
      this.sortData = [
        {name: '主题教研',value: 'visit',visitType: 1},
        {name: '专题讲座',value: 'visit',visitType: ''},
        {name: '特色课程',value: 'visit',visitType: ''},
        {name: '教材培训',value: 'visit',visitType: ''},
        {name: '互动随笔',value: 'visit',visitType: ''},
      ]
    } else if(this.htmlName == '名师工作室') {
      this.sortData = [
        {name: '访问量',value: 'visit',visitType: 1},
        {name: '成员数',value: 'visit',visitType: ''},
        {name: '研修课题数',value: 'visit',visitType: ''},
        {name: '研修活动数',value: 'visit',visitType: ''},
      ]
    } else if(this.htmlName == '学校') {
      this.sortData = [
        {name: '教研总结',value: 'visit',visitType: 1},
        {name: '"2+2"教研反馈',value: 'visit',visitType: ''},
        {name: '教学设计',value: 'visit',visitType: ''},
        {name: '教学反思',value: 'visit',visitType: ''},
        {name: '展示课例',value: 'visit',visitType: ''},
        {name: '活动风采',value: 'visit',visitType: ''},
      ]
    }
  },
  methods: {
    visitNum(item,index) {
      if(index == this.sortIndex) {
        if(item.visitType == 1) {
          this.sortData[index].visitType = 2;
        } else {
          this.sortData[index].visitType = 1;
        }
      } else {
        for(var i = 0; i < this.sortData.length; i++) {
          this.sortData[i].visitType = '';
        }
        this.sortData[index].visitType = 1;
      }
      this.sortIndex = index;
      this.$emit('handleSort', item);
    },
  }
};
</script>

<style>
  .sortZi {
    position: relative;
    margin-right: .6rem;
  }
  .sortZi .visitTit {
    color: #333;
    padding: .12rem 0px;
    display: inline-block;
    /* border-bottom: 1px solid #333; */
  }
  .sortZi:hover .visitTit {
    color: #0077FA;
    border-bottom: .01rem solid #0077FA;
  }
  .sortZi .visitTit.active {
    color: #0077FA;
    border-bottom: .01rem solid #0077FA;
  }
  .sortIcon {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
  }
  .sortIcon.down {
    right: -.15rem;
  }
  .sortIcon.up {
    right: -.22rem;
  }
  .sortRight {
    color: #9a9a9a;
    padding: .12rem 0px;
  }
  .sortBox .el-card__body {
    padding: 0px .2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sort.vue